/**
 * 模組頁面代碼 : 1320-UI-05
 * 頁面說明 : 角色新增修改視窗
 * @module web/modules/role-permission/components/RoleModal
 */

// ----- import from npm modules -----
import React, {useState, useEffect} from 'react';

// ----- constants -----
const ROLE_NEW = 'new';
const ROLE_EDIT = 'edit';

const RESPONSE_OK = 200;
const TITLE_ROLE_NEW = '新增角色維護';
const TITLE_ROLE_EDIT = '修改角色維護';

const RoleModal = React.forwardRef((props, ref) => {
  const {mode, role} = props;
  const modalIcon = mode === ROLE_NEW ? '#ico-plus' : '#ico-edit';
  const modalTitleText = mode === ROLE_NEW ? TITLE_ROLE_NEW : TITLE_ROLE_EDIT;

  // 初始化state
  const [formValues, setFormValues] = useState({
    modalRoleName: '',
    modalDescription: '',
    modalRoleLevel: 10,
  });

  const [invalidShow, setInvalidShow] = useState('none');

  // Handle change event
  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  };

  // 使用useEffect在role改變才更新formValues
  useEffect(() => {
    setFormValues({
      modalRoleName: role ? role.roleName : '',
      modalDescription: role ? role.description : '',
      modalRoleLevel: role ? role.roleLevel : 10,
    });
    setInvalidShow('none');
  }, [role]);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setInvalidShow('block');
      return;
    }
    form.classList.add('was-validated');

    // 建立 FormData 讀取表单的值
    const formData = new FormData(form);

    // 建立角色物件
    const saveRole = {
      roleId: mode === ROLE_NEW ? null : role.roleId,
      roleName: formData.get('modalRoleName'),
      description: formData.get('modalDescription'),
      roleLevel: parseInt(formData.get('modalRoleLevel')),
    };

    // 呼叫父層元件的新增或修改角色函式
    if (mode === ROLE_NEW) {
      props.addRole(saveRole).then((response) => {
        const statusCode = response.payload.code;
        if (statusCode !== RESPONSE_OK) {
          $(ref.current).modal('hide');
          props.onErrorHandle(TITLE_ROLE_NEW, response.payload);
        } else {
          // props.fetchRoleSelection();
          // 调用 fetchRoleList and Hide the modal
          props.fetchRoleList().then(() => {
            props.setNeedRoleListLoad(true);
            $(ref.current).modal('hide');
          });
        }
      });
    } else if (mode === ROLE_EDIT) {
      props.editRole(saveRole).then((response) => {
        const statusCode = response.payload.code;
        if (statusCode !== RESPONSE_OK) {
          $(ref.current).modal('hide');
          props.onErrorHandle(TITLE_ROLE_EDIT, response.payload);
        } else {
          // props.fetchRoleSelection();
          // 调用 fetchRoleList and Hide the modal
          const {roleId, moduleId} = props.searchRolePermission;
          props.fetchRolePermissionList(roleId, moduleId).then(() => {
            props.setNeedRolePermissionLoad(true);
          });
          props.fetchRoleList().then(() => {
            props.setNeedRoleListLoad(true);
            $(ref.current).modal('hide');
          });
        }
      });
    }
  };

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalRole"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalRoleLabel"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered
        modal-dialog-scrollable"
      >
        <form
          className="modal__form modal-content needs-validation"
          id="modalRoleForm"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalRoleLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href={modalIcon}></use>
                </svg>
              </div>
              <div className="modal__title__text">{modalTitleText}</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="modal__form__catagory row">
                <div className="col-3">
                  <div className="modal__form__catagory__lable">角色資訊</div>
                </div>
                <div className="col-9">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="modalRoleName" className="form-label">
                        角色名稱*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalRoleName"
                        name="modalRoleName"
                        value={formValues.modalRoleName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label htmlFor="modalDescription" className="form-label">
                        角色說明
                      </label>
                      <textarea
                        className="form-control"
                        id="modalDescription"
                        name="modalDescription"
                        value={formValues.modalDescription}
                        onChange={handleChange}
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div
                    className="alert alert-warning global-invalid-feedback"
                    style={{display: invalidShow}}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default RoleModal;
